// Avisos sonoros (fim da estimativa, fim do bloco e fim da pausa). Gerados com Web Audio,
// sem arquivo de áudio. Respeitam a preferência "Sons" (P0.8).

export type SoundKind = 'estimate' | 'focusEnd' | 'breakEnd';

const MELODIES: Record<SoundKind, number[]> = {
  estimate: [880, 660],
  focusEnd: [660, 880, 990],
  breakEnd: [523, 659, 784],
};

let ctx: AudioContext | null = null;

export function playSound(kind: SoundKind): void {
  const Ctor = (globalThis as { AudioContext?: typeof AudioContext }).AudioContext;
  if (!Ctor) return;
  try {
    ctx ??= new Ctor();
    const start = ctx.currentTime;
    MELODIES[kind].forEach((freq, i) => {
      const osc = ctx!.createOscillator();
      const gain = ctx!.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      const t = start + i * 0.18;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.25, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.16);
      osc.connect(gain).connect(ctx!.destination);
      osc.start(t);
      osc.stop(t + 0.17);
    });
  } catch {
    /* áudio bloqueado pelo navegador: segue sem som */
  }
}

export interface SoundPlayer {
  play(kind: SoundKind): void;
}

export function createSoundPlayer(enabled: () => boolean, play: (k: SoundKind) => void = playSound): SoundPlayer {
  return {
    play(kind) {
      if (enabled()) play(kind);
    },
  };
}
